jQuery(document).ready(function($) {
    const mqDesktop = window.matchMedia('(min-width: 960px)');

    $('.bloc_liens').each(function() {
        const $bloc = $(this);
        const $liens = $bloc.find('.lien-item');
        const $backgrounds = $bloc.find('.bg-item');

        function setActive(index) {
            $liens.removeClass('active');
            $liens.eq(index).addClass('active');

            $backgrounds.removeClass('active');
            $backgrounds.filter(`[data-index="${index}"]`).addClass('active');
        }

        $liens.on('mouseenter', function() {
            if (!mqDesktop.matches) return;
            const index = $(this).data('index');
            setActive(index);
        });
    });
});